import styled from "styled-components";


export const Wrapper = styled.div`
  text-align: center;
  width: 100%;
`;


export const ContentWrapper = styled.div`
    max-width: 40%;
    margin: 40px auto auto;
    display: flex;
    justify-content: center;
    flex-direction: column;
    gap: 30px;
    padding: 0 40px 40px;

    @media (max-width: 768px) {
        max-width: 100%;
        padding: 0 20px 20px;
    }

    div {
        text-align: left;
    }
`;


export const InputWrapper = styled.div`
  width: 100%;
  text-align: left;
  h1 {
    font-family: Inter;
    font-size: 14px;
    font-weight: 500;
    line-height: 16px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
  }
  p {
    font-family: Inter;
    font-size: 12px;
    font-weight: 400;
    line-height: 15.6px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
  }
`;

export const Error = styled.span`
  color: #f9123b;
  font-family: Inter;
  text-align: right;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 15.6px;
`;

export const ItemWrapper = styled.div`
  display: flex;
  gap: 10px;
  width: 100%;
`;

export const RateBox = styled.div`
    height: 40px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    border-radius: 8px;
    background-color: #f9f9f9;

    span {
        color: #000000;
        font-size: 12px;
        font-weight: 400;
        line-height: 15.6px;
    }

    .fee-box {
        display: flex;
        align-items: center;
        gap: 5px;
    }
`;

export const DetailsBox = styled.div`
  padding: 24px;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 40px;
`;

export const DetailsSectionHeader = styled.div`
  padding-bottom: 8px;
  border-bottom: 1px solid #e8e8e8;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  h1 {
    font-size: 18px;
    font-weight: 500;
    line-height: 28px;
    color: #000000;
    margin: 0;
  }

  span {
    font-size: 14px;
    font-weight: 600;
    line-height: 16px; 
    color: var(--primary-pink);
    cursor: pointer;
  }
`;

export const DetailsContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const DetailsRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: Inter;

  p {
    font-size: 16px;
    color: #767676;
    font-weight: 400;
    line-height: 24px; 
    margin: 0;
  }

  span {
    font-size: 16px;
    font-weight: 400;
    line-height: 24px; 
    color: #000000;
  }
`;

export const ContinueButton = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 15px;
  width: 100%;

  span {
    color: #565c69;
    margin-bottom: 5px;
    font-size: 12px;
  }
`;

export const TextField = styled.span`
  color: #000000;
  font-size: 12px;
  font-weight: 400;
  line-height: 15.6px;
  margin: 0;
`;

export const RateWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 16px;
  border-radius: 8px;
  background-color: #f9f9f9;
`;

export const FeeWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const Form = styled.div`
 width: 90%;
 margin: 0 auto 5rem;

 @media (min-width: 768px){
  width: 100%;
 }

`

export const InputBox = styled.div`
  display: block;
  width: 100%;
  margin-bottom: 35px;

  & > span {
    font-weight: 400;
    font-size: 10px;
    line-height: 130%;
    margin-top: 4px;
    color: var(--primary-pink);
  }

  & div[class~="ant-input-number-affix-wrapper"] {
    border: 1px solid #a3a3a3 !important;
    border-radius: 8px;
    height: 40px;
    width: 100%;
    display: flex;
    align-items: center;
    box-shadow: none !important;
    font-family: "Inter";

    & > span {
      padding-right: 8px;
      border-right: 1px solid #a3a3a3;
    }

    & > div[class="ant-input-number"] {
      padding-left: 8px;
    }
  }

  & div[class="ant-input-number-handler-wrap"] {
    display: none;
  }
`;